/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Accordion from "react-bootstrap/Accordion";
import CourseUnit from "./unit";
import { updateComponent, updateUnit } from "../../services/labServices";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const UnitsDnd = ({ unidades, setUnitInfo, setComponenInfo, setReloadData, readOnly, setComponentForm }) => {
  const [items, setItems] = useState([]);
  items.sort((a, b) => a.sort_order - b.sort_order);

  useEffect(() => {
    setItems(unidades);
  }, [unidades]);

  const findComponentsByUnit = (unitId, units) => {
    const components = [];
    units.find((unit) => {
      if (unit.id === unitId) {
        components.push(...unit.labComponent);
      }
    });

    return components;
  };
  const onDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    if (readOnly) {
      return;
    }
    const listId = result.source.droppableId;
    const unitId = listId === "units" ? "units" : JSON.parse(listId.match(/^(\d+)-droppable/)[1]);

    const listToReorder = listId === "units" ? items : findComponentsByUnit(unitId, items);
    const updatedItems = reorder(listToReorder, result.source.index, result.destination.index);
    if (listId === "units") {
      updatedItems.forEach(async (unit, index) => {
        await updateUnit(unit.id, { sort_order: index + 1 });
      });
    } else {
      const unitToUpdate = items.find((unit) => unit.id === unitId);
      unitToUpdate.labComponent = updatedItems;

      const quizComponent = updatedItems.find((component) => component.type === "Quiz");
      const otherComponents = updatedItems.filter((component) => component.type !== "Quiz");

      otherComponents.forEach(async (component, index) => {
        await updateComponent(component.id, { sort_order: index + 1 });
      });

      if (quizComponent) {
        await updateComponent(quizComponent.id, { sort_order: updatedItems.length });
      }
    }
    setReloadData(true);
  };
  return (
    <DragDropContext onDragEnd={onDragEnd} id="dnd">
      <div>
        <Droppable droppableId="units">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              <Accordion defaultActiveKey="0">
                {items.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                        <CourseUnit order={index + 1} setUnitInfo={setUnitInfo} unit={item} setComponenInfo={setComponenInfo} setComponentForm={setComponentForm} />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </Accordion>
            </div>
          )}
        </Droppable>
      </div>
    </DragDropContext>
  );
};

export default UnitsDnd;
